<template>
    <div class="newsdetail detail_span_style">
        <div class="news">
            <div class="daohang" @click="goback()">返回>行业新闻</div>
            <div class="news-content">
                <h3 class="news-title">{{infos.title}}</h3>
                <div v-html="infos.desc" class="news-desc"></div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    data(){
        return{
            contentsId:"",
            infos:{}
        }
    },
    created(){
        var local_contentsId = localStorage.getItem("contentsId");
        if(local_contentsId){
            this.contentsId = local_contentsId;
        }else{
            this.contentsId = this.$route.query.contentsId;
        }
    },
    mounted(){
        this.getDetail();
    },
    methods:{
        getDetail(){
            var this_ = this;
            $.ajax({
                    url: this_.CONFIG.URL + '/api/admin/contents/info',
                    type: "get",
                    data:{contentsId:this.contentsId},
                    success: function (data) {
                        this_.$nextTick(()=>{
                            if (data.status == '200') {
                                this_.infos = data.context;
                            }
                        });
                    },
                    error:function(data){
                        this_.$nextTick(()=>{
                            this_.$notification['error']({
                                message: '提示',
                                description:'网络异常,请稍后再试',
                                style: {
                                    position:'fixed',
                                    top:'50%',
                                    left:'50%'
                                },
                            });
                        });
                    }

                });
        },
        goback(){
            this.$router.push({
                path: "/aboutUs_news",
                query: {
                    fromId: "6",
                    parentId:"6_0"
                }
            });
            var query=this.$route.query;
            localStorage.setItem("current",JSON.stringify(query));
        }
    }
}
</script>

<style scoped lang="less">
.newsdetail{
    margin-top: 80px;
    width: 100%;
    min-width: 1200px;
    background: #fafafa;
    overflow: auto;
    .news{
        width: 1200px;
        margin: 70px auto 60px;
        text-align:left;
        .daohang{
            margin-bottom: 20px;
            display: inline-block;
            cursor: pointer;
        }
        .news-content{
            box-shadow: 0 1px 8px 0 rgba(0,0,0,.09);
            min-height: 400px;
            background: #fff;
            overflow: auto;
            h3{
                margin-top: 50px;
                line-height: 50px;
                font-size: 29px;
                text-align: center;
            }
            .news-desc{
                margin: 0 0 70px;
                padding: 0 32px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/newDetail.vue